import React from 'react';

import DeviceManagement from '../../components/Device/DeviceManagement';

export default class extends React.Component {
    render() {
        return (<DeviceManagement handleBack={() => window.history.back()} />);
    }
}


// WEBPACK FOOTER //
// ./src/route/version-3/DeviceManagementPage.js